import { createContext, useState } from "react";
import { FORGOT_PASSWORD_STEPS } from "../data/constants";

export const ForgotPasswordContext = createContext();

const ForgotPasswordContextProvider = ({ children }) => {
    const {
        EMAIL_FORM_STEP,
        VERIFICATION_CODE_FORM_STEP,
        NEW_PASSWORD_FORM_STEP,
        SUCCESS_STEP,
    } = FORGOT_PASSWORD_STEPS;

    const [currentStep, setCurrentStep] = useState(EMAIL_FORM_STEP);

	// value es el email o cuit
	const [value, setValue] = useState(null);
    const changeValue = (value) => setValue(value);

	const [recoveryByCuit, setRecoveryByCuit] = useState(false);

	const [dataResponseStep, setDataResponseStep] = useState(null);

    const changeCurrentStep = () => {
        switch (currentStep) {
            case EMAIL_FORM_STEP:
                setCurrentStep(VERIFICATION_CODE_FORM_STEP);
                break;
            case VERIFICATION_CODE_FORM_STEP:
                setCurrentStep(NEW_PASSWORD_FORM_STEP);
                break;
            case NEW_PASSWORD_FORM_STEP:
                setCurrentStep(SUCCESS_STEP);
                break;
            default:
                setCurrentStep(EMAIL_FORM_STEP);
                break;
        }
    };

    return (
        <ForgotPasswordContext.Provider
            value={{ currentStep, changeStep: changeCurrentStep,
					recoveryByCuit, setRecoveryByCuit, 
					value, changeValue,
					dataResponseStep, setDataResponseStep
				}}
        >
            {children}
        </ForgotPasswordContext.Provider>
    );
};

export default ForgotPasswordContextProvider;
